const QUEUEABLE_HTTP_STATUSES = new Set([408, 502, 503, 504]);

/**
 * Очередь предназначена только для отсутствия связи и временной
 * недоступности шлюза. Ошибки приложения (400/401/409/422/500) нельзя
 * маскировать офлайн-режимом: пользователь должен увидеть их сразу.
 */
export function isOfflineQueueableError(error) {
  const status = Number(error?.response?.status || 0);
  if (status) {
    return QUEUEABLE_HTTP_STATUSES.has(status);
  }

  if (error?.code === 'ERR_CANCELED') {
    return false;
  }

  return Boolean(
    error?.request
    || ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error?.code)
  );
}

export function isCacheableReadError(error) {
  const status = Number(error?.response?.status || 0);
  return !error?.response || [500, 502, 503, 504].includes(status);
}
